import {useEffect, useState} from "react";
import {ServiceQuery} from "../queries/ServiceQuery";
import {useServiceList} from "./useServiceList";
import {useServiceFavorite} from "./useServiceFavorite";

const useServiceDetail = (id, variant) => {

    const [isLoading, setIsLoading] = useState(false)
    const {findById} = useServiceList()
    const {removeFromFavorite, addToFavorite} = useServiceFavorite()
    const [service, setService] = useState(undefined)

    useEffect( () => {
        // @todo get detail from backend api
        const service = findById(id, variant)
        if( service ) setService(service)
    }, [id, variant] )

    const addToFav = id => {
        addToFavorite( parseInt(id) )
        setService(service => ({ ...service, isFavorite: true }))
    }

    const removeFromFav = id => {
        removeFromFavorite( parseInt(id) )
        setService(service => ({ ...service, isFavorite: false }))
    }

    return {isLoading, service, addToFav, removeFromFav}
}

export {useServiceDetail}